import { render, staticRenderFns } from "./ScoreMealim.vue?vue&type=template&id=f115268a&scoped=true"
import script from "./ScoreMealim.vue?vue&type=script&lang=js"
export * from "./ScoreMealim.vue?vue&type=script&lang=js"
import style0 from "./ScoreMealim.vue?vue&type=style&index=0&id=f115268a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f115268a",
  null
  
)

export default component.exports